import type { TranslatedString } from "@web-monorepo/i18next";
import { DDSBodyText, DDSLabelText, DDSToggle } from "@web-monorepo/dds";
import { DevToolsSettings } from "./devToolsSettings";
import styles from "./EnvironmentSection.module.css";

export const EnvironmentSection = () => {
  const { usePrecanaryEnabled, setUsePrecanaryEnabled } = DevToolsSettings.useUsePrecanaryEnabled();

  return (
    <div className={styles.root} disable-tag-translation>
      <div className={styles.sectionHeader}>
        <DDSLabelText>Environment</DDSLabelText>
      </div>
      <div className={styles.toggleRow}>
        <DDSBodyText level="md">{"Use precanary" as TranslatedString}</DDSBodyText>
        <DDSToggle
          checked={usePrecanaryEnabled}
          onCheckedChange={setUsePrecanaryEnabled}
          size="small"
          data-name="dev_tools_use_precanary_toggle"
          aria-label={"Toggle usePrecanary" as TranslatedString}
        />
      </div>
      <DDSBodyText level="sm" variant="secondary">
        {
          "When enabled, new API requests are routed to the precanary environment. Reload to refetch existing data. window.usePrecanary, if set in the console, applies regardless of this toggle." as TranslatedString
        }
      </DDSBodyText>
    </div>
  );
};
